export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:6938";

export const COURSES_ENDPOINT = `${API_BASE_URL}/api/courses`;
export const ADMIN_COURSES_ENDPOINT = `${COURSES_ENDPOINT}/admin`;
export const ADMIN_COURSES_UPDATE_ENDPOINT = (id) => `${ADMIN_COURSES_ENDPOINT}/${encodeURIComponent(id)}`;

export const UNIVERSITIES_ENDPOINT = `${API_BASE_URL}/api/universities`;
export const ADMIN_UNIVERSITIES_ENDPOINT = `${UNIVERSITIES_ENDPOINT}/admin`;
export const ADMIN_UNIVERSITIES_UPDATE_ENDPOINT = (id) => `${ADMIN_UNIVERSITIES_ENDPOINT}/${encodeURIComponent(id)}`;
export const UNIVERSITY_DETAILS_ENDPOINT = (id) => `${UNIVERSITIES_ENDPOINT}/${encodeURIComponent(id)}`;

export const APPLICATIONS_ENDPOINT = `${API_BASE_URL}/api/applications`;
export const ADMIN_APPLICATIONS_ENDPOINT = `${APPLICATIONS_ENDPOINT}/admin`;
export const ADMIN_APPLICATIONS_UPDATE_ENDPOINT = (id) => `${ADMIN_APPLICATIONS_ENDPOINT}/${id}`;
export const ADMIN_APPLICATION_APPLICANT_ENDPOINT = `${ADMIN_APPLICATIONS_ENDPOINT}/applicant`;
export const ADMIN_APPLICATIONS_SUMMARY_ENDPOINT = `${ADMIN_APPLICATIONS_ENDPOINT}/summary`;
export const APPLICATIONS_RECENT_ENDPOINT = `${APPLICATIONS_ENDPOINT}/course/recent`;

export const BLOGS_ENDPOINT = `${API_BASE_URL}/api/blogs`;
export const ADMIN_BLOGS_ENDPOINT = `${BLOGS_ENDPOINT}/admin`;
export const ADMIN_BLOGS_UPDATE_ENDPOINT = (id) => `${ADMIN_BLOGS_ENDPOINT}/${id}`;
export const BLOG_COMMENT_ENDPOINT = (slug) => `${BLOGS_ENDPOINT}/${slug}/comments`;

export const EVENTS_ENDPOINT = `${API_BASE_URL}/api/events`;
export const ADMIN_EVENTS_ENDPOINT = `${EVENTS_ENDPOINT}/admin`;
export const ADMIN_EVENTS_UPDATE_ENDPOINT = (id) => `${ADMIN_EVENTS_ENDPOINT}/${id}`;
export const EVENT_LIKE_ENDPOINT = (slug) => `${EVENTS_ENDPOINT}/${slug}/likes`;

export const INSTRUCTORS_ENDPOINT = `${API_BASE_URL}/api/instructors`;
export const ADMIN_INSTRUCTORS_ENDPOINT = `${INSTRUCTORS_ENDPOINT}/admin`;
export const ADMIN_INSTRUCTORS_UPDATE_ENDPOINT = (id) => `${ADMIN_INSTRUCTORS_ENDPOINT}/${id}`;

export const USERS_ENDPOINT = `${API_BASE_URL}/api/users`;
export const ADMIN_USERS_ENDPOINT = `${USERS_ENDPOINT}/admin`;
export const ADMIN_USERS_UPDATE_ENDPOINT = (id) => `${ADMIN_USERS_ENDPOINT}/${id}`;

export const INTAKES_ENDPOINT = `${API_BASE_URL}/api/intakes`;
export const ADMIN_INTAKES_ENDPOINT = `${INTAKES_ENDPOINT}/admin`;
export const ADMIN_INTAKES_UPDATE_ENDPOINT = (id) => `${ADMIN_INTAKES_ENDPOINT}/${encodeURIComponent(id)}`;

export const AGENTS_ENDPOINT = `${API_BASE_URL}/api/agents`;
export const ADMIN_AGENTS_ENDPOINT = `${AGENTS_ENDPOINT}/admin`;
export const ADMIN_AGENTS_UPDATE_ENDPOINT = (id) => `${ADMIN_AGENTS_ENDPOINT}/${encodeURIComponent(id)}`;

export const STATUS_TYPES_ENDPOINT = `${API_BASE_URL}/api/status-types`;
export const ADMIN_STATUS_TYPES_ENDPOINT = `${STATUS_TYPES_ENDPOINT}/admin`;
export const ADMIN_STATUS_TYPES_UPDATE_ENDPOINT = (id) => `${ADMIN_STATUS_TYPES_ENDPOINT}/${encodeURIComponent(id)}`;

export const GALLERY_ENDPOINT = `${API_BASE_URL}/api/gallery`;
export const ADMIN_GALLERY_ENDPOINT = `${GALLERY_ENDPOINT}/admin`;
export const ADMIN_GALLERY_ITEM_ENDPOINT = (fileName) => `${ADMIN_GALLERY_ENDPOINT}/${encodeURIComponent(fileName)}`;

export const TESTIMONIALS_ENDPOINT = `${API_BASE_URL}/api/testimonials`;
export const ADMIN_TESTIMONIALS_ENDPOINT = `${TESTIMONIALS_ENDPOINT}/admin`;
export const ADMIN_TESTIMONIALS_UPDATE_ENDPOINT = (id) => `${ADMIN_TESTIMONIALS_ENDPOINT}/${encodeURIComponent(id)}`;

export const COURSE_FILTERS_ENDPOINT = `${COURSES_ENDPOINT}/filters`;

export const AUTH_ENDPOINT = `${API_BASE_URL}/api/auth`;
export const AUTH_REGISTER_ENDPOINT = `${AUTH_ENDPOINT}/register`;
export const AUTH_LOGIN_ENDPOINT = `${AUTH_ENDPOINT}/login`;
export const AUTH_ME_ENDPOINT = `${AUTH_ENDPOINT}/me`;
export const AUTH_PROFILE_ENDPOINT = `${AUTH_ENDPOINT}/profile`;
export const AUTH_AVATAR_ENDPOINT = `${AUTH_ENDPOINT}/profile/avatar`;
